// extracted by mini-css-extract-plugin
export default {"centerNotFound":"not_found_centerNotFound__+RxgC","contactIcon":"not_found_contactIcon__ksVxp","ant-btn-icon":"not_found_ant-btn-icon__+975N"};